













/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Modules
 ---------------------------------------- */

import Player from '@vimeo/player';

/* ----------------------------------------
     Mixin
 ---------------------------------------- */

import BlockMixin from '@mixin/blocks';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            player: null
        }
    },

    mixins: [
        BlockMixin
    ],

    computed: {
        videoId() {
            return this.content.src.split('/').slice(-1)[0];
        }
    },

    mounted() {
        const options = {
            color: this.color,
            id: this.videoId,
            loop: true
        };

        const video = this.$el.querySelector('.video-block__video');
        this.player = new Player(video, options);
        this.player.setVolume(0);
    },

    reveal(el, _transition, component) {
        el.style.opacity = 1;
        component.player.play();
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ImageBlock extends Vue {}

